/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Document } from '../../../core/models/Document';
import { Node } from '../../../core/models/Node';
import { IExample } from '../../../core/models/common/IExample';
import { Parameter } from '../../../core/models/common/Parameter';
import { SecurityScheme } from '../../../core/models/common/SecurityScheme';
import { OasHeader } from '../../models/OasHeader';
import { OasResponse } from '../../models/OasResponse';
import { Oas20Definitions } from '../models/Oas20Definitions';
import { Oas20Document } from '../models/Oas20Document';
import { Oas20Header } from '../models/Oas20Header';
import { Oas20Headers } from '../models/Oas20Headers';
import { Oas20Items } from '../models/Oas20Items';
import { Oas20Parameter } from '../models/Oas20Parameter';
import { Oas20ParameterDefinitions } from '../models/Oas20ParameterDefinitions';
import { Oas20Response } from '../models/Oas20Response';
import { Oas20ResponseDefinitions } from '../models/Oas20ResponseDefinitions';
import { Oas20Scopes } from '../models/Oas20Scopes';
import { Oas20SecurityDefinitions } from '../models/Oas20SecurityDefinitions';
import { Oas20SecurityScheme } from '../models/Oas20SecurityScheme';
import { OasTraverser } from '../../visitors/OasTraverser';
import { IOas20Visitor } from './IOas20Visitor';
import { IVisitor } from '../../../core/visitors/IVisitor';
import { Oas20Schema } from '../models/Oas20Schema';
import { Oas20Example } from '../models/Oas20Example';

/**
 * Constructor.
 * @param {*} visitor
 * @class
 * @extends OasTraverser
 * @author eric.wittmann@gmail.com
 */
export class Oas20Traverser extends OasTraverser implements IOas20Visitor {
    public constructor(visitor : IOas20Visitor) {
        super(visitor);
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.OasTraverser#traverseDocument(io.apicurio.datamodels.core.models.Document)
     * @param {Document} node
     */
    traverseDocument(node : Document) {
        super.traverseDocument(node);
        let doc : Oas20Document = <Oas20Document>node;
        this.traverseIfNotNull(doc.definitions);
        this.traverseIfNotNull(doc.parameters);
        this.traverseIfNotNull(doc.responses);
        this.traverseIfNotNull(doc.securityDefinitions);
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.Traverser#traverseParameter(io.apicurio.datamodels.core.models.common.Parameter)
     * @param {Parameter} node
     */
    traverseParameter(node : Parameter) {
        super.traverseParameter(node);
        let param : Oas20Parameter = <Oas20Parameter>node;
        this.traverseIfNotNull(param.items);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor#visitItems(io.apicurio.datamodels.openapi.v2.models.Oas20Items)
     * @param {Oas20Items} node
     */
    public visitItems(node : Oas20Items) {
        node.accept(this.visitor);
        this.traverseIfNotNull(node.items);
        this.traverseExtensions(node);
        this.traverseValidationProblems(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor#visitScopes(io.apicurio.datamodels.openapi.v2.models.Oas20Scopes)
     * @param {Oas20Scopes} node
     */
    public visitScopes(node : Oas20Scopes) {
        node.accept(this.visitor);
        this.traverseExtensions(node);
        this.traverseValidationProblems(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor#visitSecurityDefinitions(io.apicurio.datamodels.openapi.v2.models.Oas20SecurityDefinitions)
     * @param {Oas20SecurityDefinitions} node
     */
    public visitSecurityDefinitions(node : Oas20SecurityDefinitions) {
        node.accept(this.visitor);
        this.traverseIndexedNode(node);
        this.traverseValidationProblems(node);
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitSecurityScheme(io.apicurio.datamodels.core.models.common.SecurityScheme)
     * @param {SecurityScheme} node
     */
    public visitSecurityScheme(node : SecurityScheme) {
        let node20 : Oas20SecurityScheme = <Oas20SecurityScheme>node;
        node.accept(this.visitor);
        this.traverseIfNotNull(node20.scopes);
        this.traverseExtensions(node);
        this.traverseValidationProblems(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor#visitDefinitions(io.apicurio.datamodels.openapi.v2.models.Oas20Definitions)
     * @param {Oas20Definitions} node
     */
    public visitDefinitions(node : Oas20Definitions) {
        node.accept(this.visitor);
        this.traverseIndexedNode(node);
        this.traverseValidationProblems(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor#visitParameterDefinitions(io.apicurio.datamodels.openapi.v2.models.Oas20ParameterDefinitions)
     * @param {Oas20ParameterDefinitions} node
     */
    public visitParameterDefinitions(node : Oas20ParameterDefinitions) {
        node.accept(this.visitor);
        this.traverseIndexedNode(node);
        this.traverseValidationProblems(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.OasTraverser#traverseHeader(io.apicurio.datamodels.openapi.models.OasHeader)
     * @param {OasHeader} node
     */
    traverseHeader(node : OasHeader) {
        let header : Oas20Header = <Oas20Header>node;
        this.traverseIfNotNull(header.items);
        super.traverseHeader(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitExample(io.apicurio.datamodels.core.models.common.IExample)
     * @param {*} node
     */
    public visitExample(node : IExample) {
        node.accept(this.visitor);
        this.traverseValidationProblems(<Node><any>node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor#visitHeaders(io.apicurio.datamodels.openapi.v2.models.Oas20Headers)
     * @param {Oas20Headers} node
     */
    public visitHeaders(node : Oas20Headers) {
        node.accept(this.visitor);
        this.traverseIndexedNode(node);
        this.traverseValidationProblems(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor#visitResponseDefinitions(io.apicurio.datamodels.openapi.v2.models.Oas20ResponseDefinitions)
     * @param {Oas20ResponseDefinitions} node
     */
    public visitResponseDefinitions(node : Oas20ResponseDefinitions) {
        node.accept(this.visitor);
        this.traverseIndexedNode(node);
        this.traverseValidationProblems(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.OasTraverser#traverseResponse(io.apicurio.datamodels.openapi.models.OasResponse)
     * @param {OasResponse} node
     */
    traverseResponse(node : OasResponse) {
        let response : Oas20Response = <Oas20Response>node;
        this.traverseIfNotNull(response.headers);
        this.traverseIfNotNull(response.schema);
        this.traverseIfNotNull(response.examples);
        super.traverseResponse(node);
    }
}
Oas20Traverser["__class"] = "io.apicurio.datamodels.openapi.v2.visitors.Oas20Traverser";
Oas20Traverser["__interfaces"] = ["io.apicurio.datamodels.core.visitors.IVisitor","io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor","io.apicurio.datamodels.core.visitors.ITraverser","io.apicurio.datamodels.openapi.visitors.IOasVisitor"];




